import React, { useEffect } from "react";
import { useShareRecall } from '../Components/useShareRecall';
import ShareIcon from '../Components/ShareIcon';

const Popup = ({ isOpen, closePopup, data, notFound, onImageClick }) => {
    const { share, justCopied } = useShareRecall();

    useEffect(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'unset';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div style={styles.overlay} onClick={closePopup}>
            <div style={styles.popup} onClick={(e) => e.stopPropagation()}>
              <div className="popup-scroll" style={styles.popupScroll}>
                <button style={styles.closeButton} onClick={closePopup}>
                    &times;
                </button>

                {notFound ? (
                    <div>
                        <h3>Takaisinvetoa ei löytynyt</h3>
                        <p style={styles.paragraph}>Tämä takaisinveto ei ole enää saatavilla.</p>
                    </div>
                ) : !data ? (
                    <div className="loading-status">
                        <div className="spinner"></div>
                    </div>
                ) : (
                    <>
                        {/*yhteiset*/}
                        <h3 style={styles.title}>{data.title}</h3>
                        <p style={styles.paragraph}><i>{data.formattedDate}</i></p>
                        <p><strong>Lähde: </strong>{data.sourceName}</p>

                        <button
                            className="card-button popup-share-button"
                            onClick={() => share(data)}
                            type="button"
                        >
                            <ShareIcon />
                            Jaa
                            {justCopied && <span className="share-tooltip">Linkki kopioitu!</span>}
                        </button>

                        {/*ruokavirasto*/}
                        <div dangerouslySetInnerHTML={{ __html: data.articleContentHTML }}></div>
                        {data.images?.map((img, index) => (
                            <div key={index} style={styles.imageWrapper}>
                                <img
                                    src={img.src}
                                    alt={img.alt}
                                    loading="lazy"
                                    style={styles.image}
                                    onClick={() => onImageClick(img.src)}
                                />
                            </div>
                        ))}

                        {/*vaarallisettuotteet*/}
                        <p style={styles.paragraph}>{data.content}</p>
                        <p style={styles.paragraph}>{data.details?.additionalTechnicalInformation}</p>
                        <p style={styles.paragraph}>{data.details?.moreInformationFi}</p>
                        <p style={styles.paragraph}>{data.details?.operatingInstructionsFi}</p>
                        {data.details?.images?.map((img, index) => (
                            <div key={index} style={styles.imageWrapper}>
                                <img
                                    src={img.url}
                                    alt={""}
                                    loading="lazy"
                                    style={styles.image}
                                    onClick={() => onImageClick(img.url)}
                                />
                            </div>
                        ))}
                    </>
                )}
              </div>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    popup: {
        background: '#fefefe',
        color: '#333333',
        borderRadius: '24px',
        maxWidth: '90vw',
        width: '100%',
        maxHeight: "90vh",
        overflow: "hidden",
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    popupScroll: {
        padding: '20px',
        flex: '1 1 auto',
        minHeight: 0,
        overflowY: "auto",
        overflowX: "auto",
    },
    closeButton: {
        position: 'sticky',
        top: '0',
        right: '0',
        float: 'right',
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        zIndex: 1001,
    },
    title: {
        paddingRight: '2rem',
    },
    paragraph: {
        marginTop: '10px',
    },
    imageWrapper: {
        display: "flex",
        justifyContent: "flex-start",
        margin: "15px 0",
    },
    image: {
        maxWidth: "100%",
        maxHeight: "400px",
        objectFit: "contain",
        cursor: "pointer",
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        margin: "15px 0",
        fontSize: "0.9rem",
    },
    th: {
        border: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
        backgroundColor: "#f5f5f5",
        fontWeight: "bold",
    },
    td: {
        border: "1px solid #ddd",
        padding: "8px",
        textAlign: "left",
    },
};

export default Popup;